module.exports = __webpack_public_path__ + "media/images/aloe/icons/order-5fbd29275a57711e03be45d937fb4257.svg";